/* eslint-disable */
<template>
  <div class="settings">
    <AdminNavigation ref="navigation" indexProps="9"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Email Templates</h1></div>
        <div class="header-sub-title"></div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="14"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col d-flex justify-content-end">
            <el-input style="max-width: 180px" class="mr-1" @input="search()" clearable placeholder="Template Name"
                      v-model="listParam.TemplateName"/>
            <el-input style="max-width: 130px" class="mr-1" @input="search()" clearable placeholder="TemplateID"
                      v-model="listParam.EmailTemplateID"/>
            <el-select @change="selectPage(1)" style="max-width: 160px" placeholder="Email To" class="mr-1"
                       v-model="listParam.SendTo" filterable clearable>
              <el-option v-for="item in emailToType" :key="item.value" :value="item.value" :label="item.name">
                {{ item.name }}
              </el-option>
            </el-select>
            <el-select @change="selectPage(1)" style="max-width: 160px" placeholder="Status" class="mr-1"
                       v-model="listParam.Status" filterable clearable>
              <el-option :value="1" label="Active">Active</el-option>
              <el-option :value="0" label="Inactive">Inactive</el-option>
            </el-select>
            <v-btn class="add-icon" dark @click="addNew">Add New</v-btn>
          </div>
        </div>
        <div class="content-scroll-x">
          <el-table :data="records" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}"
                    :header-cell-style="{fontWeight: 100}">
            <el-table-column
                width="120"
                prop="SmsTemplateID"
                label="ID"
                show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                show-overflow-tooltip
                label="Template Name"
                prop="TemplateName"
            >
              <template slot-scope="item">
                <span>{{ decodeURIComponent(item.row.TemplateName) }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="200"
                show-overflow-tooltip
                label="Send To"
                prop="SendTo"
            >
              <template slot-scope="item">
                <span>{{ emailToType.find(n => n.value === item.row.SendTo).name }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="180"
                show-overflow-tooltip
                label="Status"
                prop="Status"
            >
              <template slot-scope="item">
                <span>{{ item.row.Status ? 'Active' : 'Inactive' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="180"
                label="Action"
            >
              <template slot-scope="item">
                <el-button size="small" link @click="handleClickModal(item.row)">Edit</el-button>
                <el-button size="small" @click="handleDelete(item.row)">Delete</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="totalCount > listParam.pageSize" class="pagination">
            Page
            <div class="pagination-group">
              <div class="border-icon pagination-current dropdown">
                <div class="pagination-current-text">{{ listParam.pageNum }}</div>
                <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
                <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                  <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                    {{ item }}
                  </div>
                </div>
              </div>
            </div>
            <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        top="5vh"
        :close-on-click-modal="false"
        :title="!curItem.EmailTemplateID ? 'Create Email Template' : 'Edit Email Template'"
        :visible.sync="dialogVisible"
        width="80%">
      <div class="box-row">
        <div class="box-col box-col-left left-label">Template Name</div>
        <div class="box-col-right">
          <el-input v-model="curItem.TemplateName"/>
          <div v-if="hasError && !validateTemplateName" class="text-danger">
            Template Name is required.
          </div>
        </div>
        <div class="box-col box-col-left left-label">Send To</div>
        <div class="box-col-right">
          <el-select :popper-append-to-body="false" class="w-100" v-model="curItem.SendTo">
            <el-option v-for="item in emailToType" :key="item.value" :value="item.value" :label="item.name">
              {{ item.name }}
            </el-option>
          </el-select>
          <div v-if="hasError && !validateEmail" class="text-danger">
            Send To is required.
          </div>
        </div>
      </div>
      <div class="box-row">
        <div class="box-col box-col-left left-label">Status</div>
        <div class="box-col-right">
          <el-select :popper-append-to-body="false" placeholder="Status" class="w-100" v-model="curItem.Status" filterable
                     clearable>
            <el-option :value="1" label="Active">Active</el-option>
            <el-option :value="0" label="Inactive">Inactive</el-option>
          </el-select>
        </div>
        <div class="box-col box-col-left left-label">Fields</div>
        <div class="box-col-right">
          <el-select class="w-100" placeholder="Select to Fill" v-model="curValue" @change="onSelectOption" filterable>
            <el-option v-for="item in fieldList" :value="item.value" :key="item.value" :label="item.name"/>
          </el-select>
        </div>
<!--        <div class="box-col box-col-left left-label">Email cc</div>-->
<!--        <div class=" box-col-right">-->
<!--          <el-input v-model="curItem.EmailCc"/>-->
<!--        </div>-->
      </div>
      <div class="box-row">
        <div class="box-col" style="width: 14%">Content</div>
        <div style="width: 86%;">
          <textarea style="height: 100px" class="textbox" ref="editor" id="tinymceEle" v-model="curItem.Body"></textarea>
        </div>
      </div>
      <div v-if="hasError && !validateEmailBody" class="text-danger">
        SMS Body can not be empty
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="cancelModal">Cancel</el-button>
    <el-button type="primary" @click="onSave">Save</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import Header from '@/components/Header'
import {debounce} from 'lodash';
import "tinymce/tinymce";
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/skins/ui/oxide/skin.css";
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';
import 'tinymce/plugins/spellchecker'
import Editor from "@tinymce/tinymce-vue";

export default {
  name: 'AdminManageEmail',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
    Editor
  },
  data() {
    return {
      option: {
        plugins: 'link image code table spellchecker',
        browser_spellcheck: true,
        contextmenu: false,
        height: 400,
        branding: false,
        menu: false
      },
      curValue: null,
      content: '',
      hasError: false,
      records: [],
      dialogVisible: false,
      successMessage: '',
      mode: 'create',
      totalCount: 0,
      curItem: {
        TemplateName: '',
        Body: '',
        SendTo: '',
        Status: 1,
      },
      listParam: {
        pageNum: 1,
        pageSize: 10,
        EmailTemplateID: null,
        SendTo: null,
        TemplateName: '',
        Status: null
      },
      emailToType: [{
        name: 'RH2',
        value: 0
      }, {
        name: 'Client Contact',
        value: 1
      }, {
        name: 'Specialist',
        value: 2
      }, {
        name: 'Examinee',
        value: 3
      }, {
        name: 'Custom',
        value: 4
      }],
      fieldList: [],
      editorOptions: {
        lineHeight: 1
      }
    }
  },
  computed: {
    validateTemplateName() {
      return this.curItem.TemplateName.trim() !== ''
    },
    validateEmail() {
      return (this.curItem.SendTo !== null && this.curItem.SendTo !== '')
    },
    validateEmailBody() {
      return this.curItem.Body.trim() !== ''
    },
  },
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    handleDelete(item) {
      this.$confirm({
        content: 'Are you sure you want to delete this template?',
        onConfirm: async () => {
          this.curItem = item
          this.curItem.Deleted = 1
          await this.$store.dispatch("loading/setLoadComponent", true)
          await utilities.deleteSMSTemplate(this.curItem.SmsTemplateID)
          await this.$store.dispatch("loading/setLoadComponent", false)
          this.selectPage(1)
        }
      })
    },
    async onSave() {
      if(!this.validateEmail || !this.validateEmailBody || !this.validateTemplateName) {
        this.hasError = true
        return
      } else {
        this.hasError = false
      }
      // this.curItem.Body = this.curItem.Body.replaceAll("'", '%27')
     if(this.curItem.SmsTemplateID) {
       const param = {
         TemplateName: this.curItem.TemplateName,
         Body: this.curItem.Body,
         SendTo: this.curItem.SendTo,
         Status: this.curItem.Status,
       }

       await this.$store.dispatch("loading/setLoadComponent", true)
       await utilities.putSMSTemplate(this.curItem.SmsTemplateID, param)
       await this.$store.dispatch("loading/setLoadComponent", false)
     } else {
       await this.$store.dispatch("loading/setLoadComponent", true)
       await utilities.postSMSTemplate(this.curItem)
       await this.$store.dispatch("loading/setLoadComponent", false)
     }
      this.cancelModal()
      await this.loadData()
    },
    cancelModal() {
      this.dialogVisible = false
      this.curItem = {
        TemplateName: '',
        Body: '',
        SendTo: '',
        Status: 1,
      }
    },
    handleClickModal(item) {
      let obj = JSON.parse(JSON.stringify(item))
      for (let key in obj) {
        if( typeof(obj[key]) === 'string' && key !== 'Body')
        obj[key] = decodeURIComponent(obj[key])
      }
      // obj.Body = obj.Body.replaceAll("%27", "'")
      this.curItem = obj
      this.hasError = false
      this.dialogVisible = true
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },
    onSelectOption(text) {
      this.curItem.Body = this.curItem.Body + ' ' + text + ' '
    },
    async loadData() {
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      await this.$store.dispatch("loading/setLoadComponent", true)
      try {
        const {EmailTemplates, total} = await utilities.getSMSTemplate(obj)
        console.log(total)
        this.records = EmailTemplates ? EmailTemplates : []
        this.totalCount = total
        await this.$store.dispatch("loading/setLoadComponent", false)
      } catch (e) {
        this.records =  []
        this.totalCount = 0
        await this.$store.dispatch("loading/setLoadComponent", false)
      }

    },

    addNew() {
      this.curItem = {
        TemplateName: '',
            Body: '',
            SendTo: '',
            Status: 1,
      }
      this.hasError = false
      this.dialogVisible = true
    },
  },
  async beforeMount() {
    await this.loadData()
    this.fieldList = await utilities.getEmailFields()
  },
  mounted() {
  },
}
</script>
